var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"item mt-2"},[_c('a',{staticClass:"item-link",attrs:{"href":_vm.to}},[_c('v-icon',{staticClass:"item-icon"},[_vm._v(_vm._s(_vm.icon))]),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }